var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "26px",
    viewBox: "0 0 29 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon 02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Project",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login--3",
    transform: "translate(-1250.000000, -35.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menus/Horizontal/Style-01",
    transform: "translate(-1.926407, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(1211.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-02",
    transform: "translate(40.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Color",
    fill: "#3F3B3B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,19.875 C21.85,19.875 20.5,18.525 20.5,16.875 L20.5,10.5 C20.5,6.7125 17.95,3.5625 14.5,2.55 L14.5,2.25 C14.5,1.0125 13.4875,0 12.25,0 C11.0125,0 10,1.0125 10,2.25 L10,2.55 C6.55,3.5625 4,6.7125 4,10.5 L4,16.875 C4,18.525 2.65,19.875 1,19.875 L1,21.375 L8.95,21.375 C9.2875,22.875 10.6375,24 12.25,24 C13.8625,24 15.2125,22.875 15.55,21.375 L23.5,21.375 L23.5,19.875 Z M11.5,2.25 C11.5,1.8375 11.8375,1.5 12.25,1.5 C12.6625,1.5 13,1.8375 13,2.25 L13,2.2875 C12.7375,2.25 12.5125,2.25 12.25,2.25 C11.9875,2.25 11.7625,2.25 11.5,2.25 L11.5,2.25 Z M12.25,22.5 C11.5,22.5 10.825,22.05 10.525,21.375 L13.975,21.375 C13.675,22.05 13,22.5 12.25,22.5 Z M4.3375,19.875 C5.05,19.0875 5.5,18.0375 5.5,16.875 L5.5,10.5 C5.5,6.7875 8.5375,3.75 12.25,3.75 C15.9625,3.75 19,6.7875 19,10.5 L19,16.875 C19,18.0375 19.45,19.0875 20.1625,19.875 L4.3375,19.875 Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Indicator",
    fill: "#F46363",
    x: 23,
    y: -2,
    width: 6,
    height: 6,
    rx: 3
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.f8a8df8e.svg";
export { ForwardRef as ReactComponent };